import { ThingLocal, ThingPersisted } from '@inrupt/solid-client'
import { URI } from '../utils/ontology'
import { ThingFactory } from '../utils/ThingFactory'
import { SurveyElement } from './SurveyElement'
import { checkType } from './utils'

export class Answer extends SurveyElement {
  constructor(thing: ThingPersisted) {
    checkType(thing, URI.SURVEY_ANSWER_CLASS)
    super(thing)
  }
}

export class OpenAnswer extends Answer {
  constructor(thing: ThingPersisted) {
    checkType(thing, URI.SURVEY_OPEN_ANSWER_CLASS)
    super(thing)
  }
}

export const createOpenAnswer = (text: string): ThingLocal =>
  new ThingFactory()
    .addUrl(URI.TYPE_PREDICATE, URI.SURVEY_OPEN_ANSWER_CLASS)
    .addUrl(URI.TYPE_PREDICATE, URI.SURVEY_ANSWER_CLASS)
    .addUrl(URI.TYPE_PREDICATE, URI.SURVEY_SURVEY_ELEMENT_CLASS)
    .addStringNoLocale(URI.SURVEY_HAS_TEXT_PREDICATE, text)
    .build()
